import axios from "axios";
import Constants from "../constants/Constants";

export function checkAuth(callBackSuccess = () => {}, callBackFailure = () => {}){

    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'get',
        url: '/authcheck'
    }).then( res =>{
        // console.log(res)
        //remove loadingSign
        // console.log(res);
        if(res.data && res.data.authentication_result) {
            let authVo = res.data.authentication_result;
            if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token){
                callBackSuccess(authVo);
            }else{
                callBackSuccess(null);
            }
        }

    }).catch((error)=>{
        console.log(error);
        callBackFailure();
        //enable apply button
    });
}

export function xhrGetCoinRateInfoAndAuth(params, callBackSuccess, callBackFailure) {
    
    function getCoinRateInfo (){
        return axios({
            timeout: Constants.REQ_TIMEOUT,  
            method: 'get',
            url: Constants.ROUTE.RECRUITER_DASHBOARD_COMMON_HANDLER,
            params: {
                action_type: Constants.REQUEST_ACTION_TYPE.RECRUITER_DASHBOARD_COMMON_HANDLER.GET_ACTION_GET_COIN_RATE
            }
        });
    }

    function getAuthCheck (){
        return axios({
            timeout: Constants.REQ_TIMEOUT,
            method: 'get',
            url: Constants.ROUTE.AUTH_CHECK,
            
        });
    }

    Promise.all([getCoinRateInfo(), getAuthCheck()])
        .then(([coinData, authData]) => {
            let coinInfo = coinData.data.data;
            let authVo = authData.data.authentication_result;
            callBackSuccess(authVo, coinInfo);
            // if(authData.data && authData.data.authentication_result) {
            //     let authVo = authData.data.authentication_result;
            //     if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token){
            //         callBackSuccess(authVo, coinInfo);
            //     }else{
            //         callBackSuccess(null);
            //     }
            // }
        })
        .catch( error =>{
                // console.log(error);
            callBackFailure();
            })

    
}

export function saveAvailableForHirePref( avlHirePreference, callBackSuccess = () => {}, callBackFailure = () => {}){
    if(Constants.DEV_MODE){
        setTimeout(()=>{
            callBackSuccess();
        }, 3000);
        return;
    }
    
    let data = new FormData();
    data.append("is_available_for_hire", avlHirePreference);
    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'post',
        url: Constants.ROUTE.SAVE_AVL_FOR_HIRE_PREF,
        data : data
    }).then( res =>{
        // console.log(res)
        //remove loadingSign
        // console.log(res);
        callBackSuccess();

    }).catch((error)=>{
        console.log(error);
        callBackFailure();
        //enable apply button
    });
}

export function getRequestAvailableForHireStatus ( onSuccess, onFailure) {

    axios({
        timeout: Constants.REQ_TIMEOUT,
        method: 'get',
        url: Constants.ROUTE.GET_AVAILABLE_FOR_HIRE_STATUS,
        params: {

            //key value pair
        }
    }).then( res =>{
        // let data = res.data.data ;
        if(res.data && res.data.error === null) {
            let authVo = res.data.authentication_result;
            if(authVo.is_active_user && authVo.is_valid_user && authVo.is_valid_token) {
                onSuccess(res.data.data);
            }else{
                onSuccess(null)
            }
        }else{
            onSuccess(null)
        }
        //Some initial processing like Valid User Check
        //finally call success as server call was success handle other cases in callback function

    }).catch((error)=>{
        onFailure();
    });

}
//returns variable which can be used to cancel interceptor
export function getRequestInterceptor() {
    // Add a request interceptor
    return axios.interceptors.request.use(function (config) {
        // Do something before request is sent
        //showLoadingSign()
        return config;
    }, function (error) {
        // Do something with request error
        //RemoveLoadingSign
        return Promise.reject(error);
    });
}

//returns variable which can be used to cancel interceptor
export function getResponseInterceptor() {
    // Add a response interceptor
    return axios.interceptors.response.use(function (response) {
        // Do something with response data
        //RemoveLoadingSign
        return response;
    }, function (error) {

        // Do something with response error
        //RemoveLoadingSign
        return Promise.reject(error);
    });
}

export function removeRequestInterceptor(interceptorId) {
    axios.interceptors.request.eject(interceptorId)
}

export function removeResponseInterceptor(interceptorId) {
    axios.interceptors.response.eject(interceptorId)
}


export function getCancelTokenSource() {
    let CancelToken = axios.CancelToken;
    let source = CancelToken.source();

    return source
    // return source.token ;
}

export function cancelTheRequest(source) {
    // cancel the request (the message parameter is optional)
    source.cancel('Operation canceled by the user.');
}

// export default BaseServiceHandlers;


// WEBPACK FOOTER //
// ./src/services/BaseServiceHandler.js